import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ErrorBoundary } from "@/components/ui/ErrorBoundary";
import ScrollToTop from "@/components/ScrollToTop";
import { CookieConsentProvider } from "./contexts/CookieConsentContext";
import { CookieConsent } from "@/components/CookieConsent";
import { CookiePreferencesDialog } from "@/components/CookiePreferencesDialog";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import Consultation from "./pages/Consultation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import CookiePolicy from "./pages/CookiePolicy";
import AIStrategy from "./pages/AIStrategy";
import DataAnalysis from "./pages/DataAnalysis";
import AssetFinancing from "./pages/AssetFinancing";
import AIAssistants from "./pages/AIAssistants";
import { GoogleAnalyticsProvider } from "./components/GoogleAnalyticsProvider";

const queryClient = new QueryClient();

const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <CookieConsentProvider>
            <BrowserRouter>
              <GoogleAnalyticsProvider>
                <ScrollToTop />
                <Toaster />
                <Sonner />
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/consultation" element={<Consultation />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/services/discovery" element={<AIStrategy />} />
                  <Route path="/services/solution-design" element={<DataAnalysis />} />
                  <Route path="/services/asset-financing" element={<AssetFinancing />} />
                  <Route path="/services/implementation" element={<Navigate to="/services/asset-financing" replace />} />
                  <Route path="/services/performance-management" element={<AIAssistants />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <CookieConsent />
                <CookiePreferencesDialog />
              </GoogleAnalyticsProvider>
            </BrowserRouter>
          </CookieConsentProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
